module.exports = __webpack_public_path__ + "img/AC1C6D93047DFE12.42113767.png";